import { render, staticRenderFns } from "./TwitterScript.vue?vue&type=template&id=4c515675&"
import script from "./TwitterScript.vue?vue&type=script&lang=js&"
export * from "./TwitterScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports